import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=288aca61&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=ts"
export * from "./PopupDialog.vue?vue&type=script&lang=ts"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=288aca61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288aca61",
  null
  
)

export default component.exports